import React, {useState, useEffect} from 'react';
import DatePicker from 'react-datepicker';
import Input from './Input';

const DateInput = ({id, value, onChange, placeholder, className, errors=false, footer=null, icon=null, readOnly=false}) => {
    const [state, setState] = useState({showDatePicker:false});

    /*useEffect(()=>{
        console.log('DateInput value prop', typeof value, value, toDateString(value));
        // eslint-disable-next-line
    },[value]);*/

    const onDateChange = (value) => {
        // console.log('onDateChange ',value, toDateString(value));
        onChange(toDateString(value));
        setState({
            showDatePicker: false
        });
    };

    const onDateSelect = (value) => {
        setState({
            ...state,
            showDatePicker: false
        });
    }

    const toUTCDate = (dateValue) => {
        //console.log(typeof dateValue);
        if(dateValue &&typeof dateValue !== 'string') {
            return new Date(Date.UTC(
                dateValue.getUTCFullYear(),
                dateValue.getUTCMonth(),
                dateValue.getUTCDate()
            ));
        }
        return dateValue;
    }


    const toDateString = (dateValue) => {
        //console.log(typeof dateValue, dateValue);
        if(dateValue) {
            if(typeof dateValue === 'string') {
                return dateValue.slice(0, 10);
            } else {
                return dateValue.toISOString().slice(0, 10);
            
            }
        }
        return dateValue;
    }

    const toggleDatePicker = () => {
        setState({
            ...state,
            showDatePicker: !state.showDatePicker,
        });
    };

    const closeDatePicker = (e) => {
        //console.log(e?.target?.id);
        if(e?.target?.id !== 'dateOfBirth') {
            setState({
                ...state,
                showDatePicker: false,
            });
        }
    };


    const openDatePicker = () => {
        setState({
            ...state,
            showDatePicker: true,
        });
    };

    const formatDate = (date) => {
        if(date) {
            //console.log(date);
            date = toUTCDate((typeof date === 'string')?new Date(date.slice(0, 10)):date);
            //console.log(date.toISOString());
            try {
                return date ? date.toLocaleDateString(undefined, {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                }):'';
            } catch (e) {}
        }
        return '';
    };

    return <div className={` ${className??className}`}>
        <div onClick={() => toggleDatePicker()}>
            <Input className={errors?"error":""} id={id} placeholder={placeholder} value={formatDate(value)} readOnly={readOnly} />
        </div>
        <div className='date-picker'>
            {state.showDatePicker && 
                <DatePicker
                    selected={toDateString(value)}
                    onSelect={(date) => 
                        onDateSelect(date)
                    }
                    onChange={(date) => 
                        onDateChange(date)
                    }
                    //dateFormat="yyyy-MM-dd"
                    onClickOutside={(e) => closeDatePicker(e)}
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                    inline
                />
            }
        </div>
    </div>;
};

export default DateInput;